import { useAnalytics } from '../../v2/third-party-integration/amplitude';
import { AMPLITUDE_EVENTS, EMPTY_STRING } from '../../constants';
import { useGlobalSearchStore, useRouteStore } from '../../Store';
import GlobalSearchRemote from "../GlobalSearchRemote/GlobalSearchRemote";
import { useAllWorkflowsAndApplications } from '../../hooks/queries';
import { usePaneManagement } from '../../contexts/PaneManagementContext';
import { setDocumentTitle } from '../../util/TitleManager';
import { createBrowserHistory } from 'history';
import { URL_ROUTES } from '../../constants';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/Theme';
import {useEffect } from 'react';

export default function GlobalSearchHistory() {
    const setWasPaneOpened = useGlobalSearchStore((state: any) => state.setWasPaneOpened);
    const wasPaneOpened = useGlobalSearchStore((state: any) => state.wasPaneOpened);
       const { trackEvent } = useAnalytics();
    const history = createBrowserHistory();
    const { i18n } = useTranslation();
    const { darkMode } = useTheme();

    const { data } = useAllWorkflowsAndApplications();
    const previousRoute = useRouteStore((state: any) => state.previousRoute);
    const setRoute = useRouteStore((state: any) => state.setRoute);
    const setPreviousRoute = useRouteStore((state: any) => state.setPreviousRoute);
    const { activePane, isPaneExpaneded, toggleIsPaneExpanded } = usePaneManagement();
    const setSearchQuery = useGlobalSearchStore((state: any) => state.setSearchQuery);

    const workflowNames = data.map((app: any) => {
        const workflow = app.appId
            ? {
                ...app,
                logoutUrl:
                    data.find((item) => item.id === app.appId)?.logoutUrl || '',
            }
            : { ...app };
        return workflow;
    });

    const hideFeedbackAndAiva = () => {
        const feedbackButton = document.querySelector(".QSIFeedbackButton") as HTMLElement | null;
        if (feedbackButton) {
            feedbackButton.style.display = "none";
        }
        const aiva = document.querySelector(".aiva-unify") as HTMLElement | null;
        if (aiva) {
            aiva.style.display = "none";
        }
        const pullupContainer = document.querySelector("#QSIFeedbackButton-target-container") as HTMLElement | null;
        if (pullupContainer) {
            pullupContainer.style.display = "none";
        }
    }

    useEffect(() => {
        hideFeedbackAndAiva();
    }, []);

    const handleBackButton = () => {
        if (wasPaneOpened) {
            const app = (workflowNames || data).find((workflow: any) => workflow.id === activePane);
            isPaneExpaneded ? setDocumentTitle(EMPTY_STRING, EMPTY_STRING) : setDocumentTitle(activePane ? app?.name : EMPTY_STRING, EMPTY_STRING);
            setWasPaneOpened(false);
            toggleIsPaneExpanded(true);
        }
        if (previousRoute === '') {
            setRoute('/applications');
        }
        else {
            setRoute(previousRoute);
        }
        setPreviousRoute('');
        trackEvent(AMPLITUDE_EVENTS.HEADER_ITEM_SELECTED, { 'Item': 'Global Search History Back Button' });
    };

    const handleViewMore = (query: string) => {
            setSearchQuery(query);
            isPaneExpaneded && setWasPaneOpened(true);
            setDocumentTitle(EMPTY_STRING, EMPTY_STRING);
            const path = window.location.pathname ? window.location.pathname : '/applications';
            if (window.location.pathname !== '/pulse'
                && window.location.pathname !== '/global-search'
                && window.location.pathname !== '/dealer-admin'
                && window.location.pathname !== '/global-search-history') {
                setPreviousRoute(path);
            }
            hideFeedbackAndAiva();
            history.push(URL_ROUTES.globalSearch);
            setRoute(URL_ROUTES.globalSearch);
            toggleIsPaneExpanded(false);
        }

    return (
        <GlobalSearchRemote
            variant="history"
            onBackButtonClicked={handleBackButton}
            viewMore={handleViewMore}
            lng={i18n.language}
            darkMode={!!darkMode}
        />
    );
}